import React from 'react';
import { SETTING } from 'interfaces/settings';

export enum SettingOptionType {
    MULTI = 'multi',
    SINGLE = 'single',
    LOGGING = 'logging',
}

export interface SettingRowMulti {
    settings: SETTING[];
    rowLabel: string;
    type: SettingOptionType.MULTI
}

export interface SettingRowSingle {
    setting: SETTING
    type: SettingOptionType.SINGLE
}

export interface AutomationOption {
    type: SettingOptionType.LOGGING
}

export type SettingOption = SettingRowMulti | SettingRowSingle | AutomationOption

export interface SettingSectionConfig {
    section: string;
    options: SettingOption[];
}
